import { find } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { loaderSelector } from '@client/selectors';
import { selectItemById } from '../lib';

/**
 * Checks to see if the specified scope is currently loading
 * @param  {any} loaders
 * @param  {string} scope
 * @return {boolean}
 */
export const inProgress = createSelector(
  loaderSelector,
  selectItemById,
  (scopes, scope) => {
    const item = find(scopes, ['name', scope]);

    if (!item) {
      return null;
    }

    return item.loading;
  },
);

/**
 * Checks to see if the specified scope is currently complete and in a success state
 * @param  {any} loaders
 * @param  {string} scope
 * @return {boolean}
 */
export const loaderHasSucceeded = createSelector(
  loaderSelector,
  selectItemById,
  (scopes, scope) => {
    const item = find(scopes, ['name', scope]);

    if (!item) {
      return false;
    }

    return (item.loading === false && item.status === true);
  },
);

/**
 * Checks to see if the specified scope is currently complete and in a success state
 * @param  {any} loaders
 * @param  {string} scope
 * @return {any}
 */
export const loaderHasSucceededData = createSelector(
  loaderSelector,
  selectItemById,
  (scopes, scope) => {
    const item = find(scopes, ['name', scope]);

    if (!item) {
      return false;
    }

    return item.loading === false && item.status === true && item.data;
  },
);

/**
 * Checks to see if the specified scope is currently complete and in a fail state.
 * If it's in a fail state, return the error message
 * @param  {any} loaders
 * @param  {string} scope
 * @return {boolean|string}
 */
export const loaderHasFailed = createSelector(
  loaderSelector,
  selectItemById,
  (scopes, scope): string | false => {
    const item = find(scopes, ['name', scope]);

    if (!item) {
      return false;
    }

    return (item.loading === false && item.status === false) ? item.error : false;
  },
);
